class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      if (this.input.value.includes('title:') || this.input.value.includes('sku:')) {
        const rawWords = this.input.value
          .replace(/[:()]/g, ' ')
          .split(/\s+/)
          .filter((w) => w && !w.startsWith('title') && !w.startsWith('sku') && w !== 'OR' && w !== 'AND')
          .map((w) => w.replace(/\*$/, ''));
        const uniqueWords = [...new Set(rawWords)];
        if (uniqueWords.length > 0) {
          this.input.value = uniqueWords.join(' ');
        }
      }
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.setAttribute('name', 'q');
      const hiddenInput = this.input.form.querySelector('input[type="hidden"][data-scoped-search]');
      if (hiddenInput) hiddenInput.remove();
      this.input.focus();
      this.toggleResetButton();
    }
  }

  onFormSubmit(event) {
    if (!this.input || !this.input.value.trim()) return;
    const rawValue = this.input.value.trim();
    if (!rawValue.includes('title:') && !rawValue.includes('sku:')) {
      const clean = rawValue.replace(/[:()]/g, ' ').trim();
      const words = clean.split(/\s+/).filter((w) => w.length > 0);
      if (words.length > 0) {
        const titleParts = words.map((w) => `title:${w}*`).join(' ');
        const skuParts = words.map((w) => `sku:${w}*`).join(' ');
        const scopedQuery = `(${titleParts}) OR (${skuParts})`;

        // Use a hidden input to submit the scoped query so this.input.value
        // is never changed visually on screen
        let hiddenInput = this.input.form.querySelector('input[type="hidden"][data-scoped-search]');
        if (!hiddenInput) {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'q';
          hiddenInput.setAttribute('data-scoped-search', 'true');
          this.input.form.appendChild(hiddenInput);
        }
        hiddenInput.value = scopedQuery;

        // Temporarily remove name from the visible input so browser submits hiddenInput instead
        this.input.removeAttribute('name');

        setTimeout(() => {
          this.input.setAttribute('name', 'q');
        }, 100);
      }
    }
  }
}

customElements.define('search-form', SearchForm);
